export default __webpack_public_path__ + "static/media/warning.14b68440.svg";